// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class UsageComparisonResponse implements flatbuffers.IUnpackableObject<UsageComparisonResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UsageComparisonResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUsageComparisonResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageComparisonResponse,
  ): UsageComparisonResponse {
    return (obj || new UsageComparisonResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsUsageComparisonResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageComparisonResponse,
  ): UsageComparisonResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UsageComparisonResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  liftName(): string | null;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  liftName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cycles(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  reopens(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  rearCycles(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  rearReopens(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  starts(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  carcalls(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  hallcalls(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startUsageComparisonResponse(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, liftNameOffset, 0);
  }

  static addCycles(builder: flatbuffers.Builder, cycles: number) {
    builder.addFieldInt32(1, cycles, 0);
  }

  static addReopens(builder: flatbuffers.Builder, reopens: number) {
    builder.addFieldInt32(2, reopens, 0);
  }

  static addRearCycles(builder: flatbuffers.Builder, rearCycles: number) {
    builder.addFieldInt32(3, rearCycles, 0);
  }

  static addRearReopens(builder: flatbuffers.Builder, rearReopens: number) {
    builder.addFieldInt32(4, rearReopens, 0);
  }

  static addStarts(builder: flatbuffers.Builder, starts: number) {
    builder.addFieldInt32(5, starts, 0);
  }

  static addCarcalls(builder: flatbuffers.Builder, carcalls: number) {
    builder.addFieldInt32(6, carcalls, 0);
  }

  static addHallcalls(builder: flatbuffers.Builder, hallcalls: number) {
    builder.addFieldInt32(7, hallcalls, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(8, liftId, 0);
  }

  static endUsageComparisonResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createUsageComparisonResponse(
    builder: flatbuffers.Builder,
    liftNameOffset: flatbuffers.Offset,
    cycles: number,
    reopens: number,
    rearCycles: number,
    rearReopens: number,
    starts: number,
    carcalls: number,
    hallcalls: number,
    liftId: number,
  ): flatbuffers.Offset {
    UsageComparisonResponse.startUsageComparisonResponse(builder);
    UsageComparisonResponse.addLiftName(builder, liftNameOffset);
    UsageComparisonResponse.addCycles(builder, cycles);
    UsageComparisonResponse.addReopens(builder, reopens);
    UsageComparisonResponse.addRearCycles(builder, rearCycles);
    UsageComparisonResponse.addRearReopens(builder, rearReopens);
    UsageComparisonResponse.addStarts(builder, starts);
    UsageComparisonResponse.addCarcalls(builder, carcalls);
    UsageComparisonResponse.addHallcalls(builder, hallcalls);
    UsageComparisonResponse.addLiftId(builder, liftId);
    return UsageComparisonResponse.endUsageComparisonResponse(builder);
  }

  unpack(): UsageComparisonResponseT {
    return new UsageComparisonResponseT(
      this.liftName(),
      this.cycles(),
      this.reopens(),
      this.rearCycles(),
      this.rearReopens(),
      this.starts(),
      this.carcalls(),
      this.hallcalls(),
      this.liftId(),
    );
  }

  unpackTo(_o: UsageComparisonResponseT): void {
    _o.liftName = this.liftName();
    _o.cycles = this.cycles();
    _o.reopens = this.reopens();
    _o.rearCycles = this.rearCycles();
    _o.rearReopens = this.rearReopens();
    _o.starts = this.starts();
    _o.carcalls = this.carcalls();
    _o.hallcalls = this.hallcalls();
    _o.liftId = this.liftId();
  }

  unpackFields(...fields: string[]): UsageComparisonResponseT {
    const t = new UsageComparisonResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("cycles")) {
      t.cycles = this.cycles();
    }
    if (fieldSet.has("reopens")) {
      t.reopens = this.reopens();
    }
    if (fieldSet.has("rear_cycles")) {
      t.rearCycles = this.rearCycles();
    }
    if (fieldSet.has("rear_reopens")) {
      t.rearReopens = this.rearReopens();
    }
    if (fieldSet.has("starts")) {
      t.starts = this.starts();
    }
    if (fieldSet.has("carcalls")) {
      t.carcalls = this.carcalls();
    }
    if (fieldSet.has("hallcalls")) {
      t.hallcalls = this.hallcalls();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    return t;
  }
}

export class UsageComparisonResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public liftName: string | Uint8Array | null = null,
    public cycles: number = 0,
    public reopens: number = 0,
    public rearCycles: number = 0,
    public rearReopens: number = 0,
    public starts: number = 0,
    public carcalls: number = 0,
    public hallcalls: number = 0,
    public liftId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;

    return UsageComparisonResponse.createUsageComparisonResponse(
      builder,
      liftName,
      this.cycles,
      this.reopens,
      this.rearCycles,
      this.rearReopens,
      this.starts,
      this.carcalls,
      this.hallcalls,
      this.liftId,
    );
  }

  clone(): UsageComparisonResponseT {
    const obj = new UsageComparisonResponseT();
    obj.liftName = this.liftName;
    obj.cycles = this.cycles;
    obj.reopens = this.reopens;
    obj.rearCycles = this.rearCycles;
    obj.rearReopens = this.rearReopens;
    obj.starts = this.starts;
    obj.carcalls = this.carcalls;
    obj.hallcalls = this.hallcalls;
    obj.liftId = this.liftId;
    return obj;
  }

  equals(other: UsageComparisonResponseT): boolean {
    if (this.liftName !== other.liftName) return false;
    if (this.cycles !== other.cycles) return false;
    if (this.reopens !== other.reopens) return false;
    if (this.rearCycles !== other.rearCycles) return false;
    if (this.rearReopens !== other.rearReopens) return false;
    if (this.starts !== other.starts) return false;
    if (this.carcalls !== other.carcalls) return false;
    if (this.hallcalls !== other.hallcalls) return false;
    if (this.liftId !== other.liftId) return false;
    return true;
  }
}

export function verifyUsageComparisonResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 2);
  } finally {
    verifier.popDepth();
  }
}
